/* Shared layout for the four session surfaces, so a sign-in, a wait and an error all sit
 * in the same place on the page instead of jumping as the state settles. */

.main {
  padding-block: var(--space-7) var(--space-8);
}

.panel {
  inline-size: 100%;
  max-inline-size: 34rem;
  margin-inline: auto;
  display: grid;
  gap: var(--space-4);
}

.wide {
  max-inline-size: none;
}

.title {
  font-size: var(--text-2xl);
}

.body {
  color: var(--text-muted);
  max-inline-size: var(--measure);
}

.footnote {
  color: var(--text-muted);
  font-size: var(--text-sm);
  max-inline-size: var(--measure);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-block-start: var(--space-1);
}

@media (min-width: 48rem) {
  .main {
    padding-block: var(--space-9) var(--space-10);
  }
}
